


import { mapActions, mapGetters } from "vuex";

export default {
    // name: 'settings',
    // props: [],
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters("admin", ["settingsList", "loadingSettings", "getFieldFromSettings"])
    },

    methods: {
        ...mapActions("admin", ["getSettingsList"])
    },

    mounted() {
        this.getSettingsList();
    }

};

